import { defineStore } from 'pinia'
import type { RouteRecordName } from 'vue-router'
import type { EnhancedRouteLocation } from '@/router/types'

const useRouteCacheStore = defineStore('route-cache', () => {
  const routeCaches = ref<RouteRecordName[]>([])

  const addRoute = (route: EnhancedRouteLocation) => {
    if (routeCaches.value.includes(route.name))
      return

    if (route?.meta?.keepAlive)
      routeCaches.value.push(route.name)
  }

  // 添加清除路由缓存的方法
  const clearRouteCache = () => {
    routeCaches.value = []
  }

  return {
    routeCaches,
    addRoute,
    clearRouteCache, // 导出清除方法
  }
})

export default useRouteCacheStore
